import React from 'react';
import { Button } from '@framework-controls/core';
import css from './MenuBackBtn.module.scss';
import { strings } from 'src/localization';
import { IconBackArrow } from 'src/content/icons';
import classNames from 'classnames';
import { THEME } from 'src/constants/ThemeNames';

interface IProps {
    theme: string;
    menuOpen?: boolean;
    extraPadding?: boolean;
    click: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const MenuBackBtn = (props: IProps) => {
    const wrapper = classNames(
        css.wrapper,
        {
            [css.extraPadding]: props.extraPadding,
            [css.menuOpen]: props.menuOpen,
            [css.wrapperAudi]: props.theme === THEME.AUDI,
        },
    );

    const menuIcon = classNames(
        css.menuIcon,
        {
            [css.menuIconCadillac]: props.theme === 'cadillac',
            [css.menuIconGMC]: props.theme === 'gmc',
            [css.menuIconAudi]: props.theme === THEME.AUDI,
        },
    );

    const menuLit = classNames(
        css.menuLit,
        {
            [css.menuLitIN]: props.theme === 'infiniti',
            [css.menuLitNissan]: props.theme === 'nissan',
            [css.menuLitGMC]: props.theme === 'gmc',
            [css.menuLitAcure]: props.theme === 'acura',
            [css.menuLitAudi]: props.theme === THEME.AUDI,
        },
    );

    return <div className={wrapper}>
        <Button
            id='backBtn'
            onClick={props.click}
            variant={'menuBackBtn'}
            type={'custom'}
            tooltip={strings.BackTitle}
        >
            <div className={menuIcon}>
                {<IconBackArrow style={{ height: '2.5rem' }} />}
            </div>
            <div className={menuLit}>{strings.Back}</div>
        </Button>
    </div>;
};

export default MenuBackBtn;